import React from "react";
import { X, Plug } from "lucide-react";
import BrandsTab from "pages/Profile/components/BrandsTab";

/**
 * ConnectionsModal - Modal wrapper for brands & ad connections
 * Mismo contenido que la pestaña Marcas del perfil
 */
const ConnectionsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 modal-safe-area bg-black/70 backdrop-blur-sm flex items-center justify-center z-[10000] p-4 pt-20"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="backdrop-blur-xl bg-gradient-to-br from-slate-800/95 via-slate-900/95 to-indigo-900/95 border border-white/20 rounded-2xl shadow-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto flex flex-col relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white/70 hover:text-white transition-all duration-200 p-1.5 rounded-full hover:bg-white/20 backdrop-blur-sm border border-white/10 hover:border-white/30 hover:scale-110 z-10"
          aria-label="Cerrar"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Header */}
        <div className="w-full flex flex-col items-start px-8 pt-8 pb-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-500/40 flex items-center justify-center backdrop-blur-md">
              <Plug className="w-5 h-5 text-white" />
            </div>
            <div>
              <h2 className="text-lg md:text-xl font-bold text-white leading-tight">
                Marcas y conexiones
              </h2>
              <p className="text-sm text-white/70">
                Elegí la marca activa y conectá Google Ads y Meta
              </p>
            </div>
          </div>
        </div>

        <div className="w-full border-t border-white/20" />

        {/* Content - only Google and Meta connections */}
        <div className="flex-1 min-h-0 p-4 md:p-6">
          <BrandsTab variant="connectionsOnly" />
        </div>
      </div>
    </div>
  );
};

export default ConnectionsModal;
